module.exports = __webpack_public_path__ + "img/out-of-money.751fc903.png";